import { AffiliateClientDto } from 'api/Affiliate/AffiliateClientDto'
import { AffiliateDto } from 'api/Affiliate/AffiliateDto'
import { NameDto } from 'api/Common/Types'
import { PageData } from 'api/Pagination/Types'
import { ScreeningResultsDto } from 'api/WorldCheck/Types/ScreeningResultsDto'
import { AffiliateUpdateDto } from 'routes/Records/Affiliates/RecordsAffiliates/Details/AffiliateDetailsForm'

import { PageQuery, preparePageQueryParams } from '.'
import { AuditLog } from '../../api/Clients/Types/AuditLog'
import { ApiClient } from './ApiClient'

export class AffiliateApiClient {
  constructor(private apiClient: ApiClient) {}

  getAffiliates: (query?: PageQuery) => Promise<PageData<AffiliateDto[]>> = (query) => {
    return this.apiClient.get(`affiliates/affiliates?${preparePageQueryParams(query)}`)
  }
  getAffiliate: (id: string) => Promise<AffiliateDto> = (id) => {
    return this.apiClient.get(`affiliates/affiliates/${id}`)
  }

  getAffiliateTypes: () => Promise<NameDto[]> = () => {
    return this.apiClient.get('affiliates/affiliates/affiliate-types')
  }

  getAffiliateCountries: () => Promise<NameDto[]> = async () =>
    this.apiClient.get('affiliates/affiliates/countries')

  getAffiliateClients: (
    affiliateCode: string,
    query?: PageQuery
  ) => Promise<PageData<AffiliateClientDto[]>> = (affiliateCode, query?: PageQuery) => {
    return this.apiClient.get(
      `/affiliates/clients/get-by-affiliate-code/${affiliateCode}?${preparePageQueryParams(query)}`
    )
  }

  updateAffiliate: (id: string, data: AffiliateUpdateDto) => Promise<void> = (id, data) => {
    return this.apiClient.put(`affiliates/affiliates/${id}`, data)
  }

  affiliateWorldCheck: (affiliateId: string) => Promise<ScreeningResultsDto | undefined> = (
    affiliateId
  ) => {
    return this.apiClient.post('affiliates/affiliates/worldcheck', { affiliateId })
  }
  getAffiliateEvents: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`affiliates/affiliates/${id}/events`)
  }
}
